import React, { useState } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";

export default function EditableField ({
    value,
    placeholder,
    onSave,
    onChange,
    type = "text",
    className,
    style,
    options = [],
    children
}) {
    const [isEditing, setIsEditing] = useState(false);
    const [fieldValue, setFieldValue] = useState(value || "");

    // Update fieldValue if parent value changes
    React.useEffect(() => {
        setFieldValue(value || "");
    }, [value]);

    const handleConfirm = async () => {
        if (fieldValue !== value) {
            await onSave(fieldValue);
        }
        setIsEditing(false);
    };

    const handleCancel = () => {
        setFieldValue(value || "");
        setIsEditing(false);
    };

    const handleKeyDown = async e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            await handleConfirm();
        } else if (e.key === 'Escape') {
            handleCancel();
        }
    };

    return isEditing ? (
        <>
            {type === "select" ? (
                <select
                    value={fieldValue}
                    onChange={e => {
                        setFieldValue(e.target.value);
                        if (onChange) onChange(e.target.value);
                    }}
                    onBlur={handleConfirm}
                    onKeyDown={handleKeyDown}
                    className={className}
                    style={style}
                    autoFocus
                >
                    {options.map(opt => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
            ) : (
                <input
                    type={type}
                    value={fieldValue}
                    onChange={e => {
                        setFieldValue(e.target.value);
                        if (onChange) onChange(e.target.value);
                    }}
                    onBlur={handleConfirm}
                    onKeyDown={handleKeyDown}
                    autoFocus
                    className={className}
                    style={style}
                />
            )}
            {children}
        </>
    ) : (
        <span
            className={className}
            style={{ cursor: "pointer", borderBottom: "1px solid #4097b7", padding: "5px", ...style }}
            title="Click to edit"
            onClick={() => setIsEditing(true)}
        >
            {fieldValue === "" ? placeholder : fieldValue}
        </span>
    );
}
